plpBestsellerBannerTest();

async function plpBestsellerBannerTest() {
    const plpBestsellerBannerTestId = "caea242c-a0d2-4141-aaff-b99edf94564f"; 
    const onVariant = await shoplift.isHypothesisActive(plpBestsellerBannerTestId);
    if (onVariant) {
      document.head.innerHTML += `
      <style>
        [data-varify-bundle-promotion-variant] {
            display: block !important;
        }

        [data-varify-bundle-promotion-original] {
            display: none !important;
        }
      </style>`;
    }
}